import React from 'react';

export type ClientStatus = 'Ativo' | 'Lead' | 'Negociação' | 'Inativo' | 'Cliente VIP' | 'Em risco';

interface ClientStatusBadgeProps {
  status: string;
}

export default function ClientStatusBadge({ status }: ClientStatusBadgeProps) {
  const s = status?.trim() || 'Ativo';
  
  let styles = 'bg-emerald-50 text-emerald-700 border border-emerald-100/80';
  let label = s;

  const upper = s.toUpperCase();
  if (upper === 'ATIVO' || upper === 'ACTIVE') {
    styles = 'bg-emerald-50 text-emerald-700 border border-emerald-100/80';
    label = 'Ativo';
  } else if (upper === 'LEAD') {
    styles = 'bg-indigo-50 text-indigo-700 border border-indigo-100/80';
    label = 'Lead';
  } else if (upper === 'NEGOCIAÇÃO' || upper === 'NEGOCIACAO' || upper === 'NEGOTIATION') {
    styles = 'bg-amber-50 text-amber-700 border border-amber-100/80';
    label = 'Negociação';
  } else if (upper === 'INATIVO' || upper === 'INACTIVE') {
    styles = 'bg-slate-50 text-slate-500 border border-slate-200/80';
    label = 'Inativo';
  } else if (upper === 'VIP' || upper === 'CLIENTE VIP') {
    styles = 'bg-purple-50 text-purple-700 border border-purple-100/80';
    label = 'Cliente VIP';
  } else if (upper === 'EM RISCO' || upper === 'AT_RISK' || upper === 'RISK') {
    styles = 'bg-rose-50 text-rose-700 border border-rose-100/80';
    label = 'Em risco';
  }

  return (
    <span id={`status-badge-${label.toLowerCase().replace(/\s+/g, '-')}`} className={`inline-flex items-center px-2.5 py-1 rounded-lg text-[10px] font-black uppercase tracking-wider ${styles}`}>
      <span className="w-1 h-1 rounded-full bg-current mr-1.5" />
      {label}
    </span>
  );
}
